import { withStyles } from "@material-ui/core/styles";
import Mapa from "./Mapa";
import styles from "./styles";

export default withStyles(styles)(Mapa);
